(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-overlay-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.feature-overlay-tabs').forEach(function (root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    var panels = root.querySelectorAll('[role="tabpanel"]');
    var current = 0;
    function activate(idx) {
      if (idx === current) return;
      var prev = current;
      current = idx;
      root.setAttribute('data-dir', idx > prev ? 'next' : 'prev');
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, i) {
        p.classList.remove('is-entering', 'is-leaving');
        if (i === idx) {
          p.hidden = false;
          p.classList.add('is-active', 'is-entering');
        } else if (i === prev) {
          p.classList.remove('is-active');
          p.classList.add('is-leaving');
        } else {
          p.classList.remove('is-active');
          p.hidden = true;
        }
      });
      var leaving = panels[prev];
      window.setTimeout(function () {
        leaving.classList.remove('is-leaving');
        if (!leaving.classList.contains('is-active')) leaving.hidden = true;
        panels[idx].classList.remove('is-entering');
      }, 640);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (n !== null) { e.preventDefault(); tabs[n].focus(); activate(n); }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
